import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "bg-warmgray-400 flex min-h-screen flex-col bg-opacity-20" }
const _hoisted_3 = { class: "w-full flex-1" }
const _hoisted_4 = { class: "bg-blue-300" }
const _hoisted_5 = { class: "relative flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-warmgray-900 text-opacity-60" }, "menu", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-full items-center" }, "Firebase Vue3 kit", -1)
const _hoisted_9 = { class: "fixed top-0 left-0 z-30 flex h-screen w-screen" }
const _hoisted_10 = { class: "bg-warmgray-100 flex w-64 flex-col bg-white shadow" }
const _hoisted_11 = { class: "top-0 w-full sm:relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuList = _resolveComponent("MenuList")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Languages = _resolveComponent("Languages")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMenu())),
              class: "inline-flex h-14 w-14 flex-shrink-0 cursor-pointer items-center justify-center"
            }, _hoisted_7),
            _hoisted_8,
            _withDirectives(_createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_MenuList, {
                  onCloseMenu: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleMenu()))
                })
              ]),
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleMenu())),
                class: "flex-1 cursor-pointer bg-black bg-opacity-40"
              })
            ], 512), [
              [_vShow, _ctx.menu]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_router_view)
        ])
      ])
    ]),
    _createVNode(_component_Languages, { class: "mt-4" })
  ]))
}